<template>
  <form :action="formAction" :method="effectiveMethod === 'get' ? 'get' : 'post'" class="form-horizontal">
    <input v-if="csrfToken && effectiveMethod !== 'get'" type="hidden" name="authenticity_token" :value="csrfToken">
    <input v-if="effectiveMethod !== 'post' && effectiveMethod !== 'get'" type="hidden" name="_method" :value="effectiveMethod">

    <div class="form-group row">
      <label class="col-sm-3 control-label" for="network_name">Name</label>
      <div class="col-sm-9">
        <input id="network_name" v-model="name" name="network[name]" type="text" class="form-control">
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-3 control-label" for="network_ipv4">IPv4 Prefix</label>
      <div class="col-sm-9">
        <input id="network_ipv4" v-model="ipv4" name="network[ipv4]" type="text" class="form-control">
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-3 control-label" for="network_ipv6">IPv6 Prefix</label>
      <div class="col-sm-9">
        <input id="network_ipv6" v-model="ipv6" name="network[ipv6]" type="text" class="form-control">
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-3 control-label" for="network_vlan">VLAN ID</label>
      <div class="col-sm-9">
        <input id="network_vlan" v-model="vlan" name="network[vlan]" type="text" class="form-control">
      </div>
    </div>

    <NetworkFormControls
      :options="segmentTypeOptions"
      :initial-value="segmentTypeId"
    />

    <div class="form-group row">
      <label class="col-sm-3 control-label" for="network_interface_name">Interface name</label>
      <div class="col-sm-9">
        <input id="network_interface_name" v-model="interfaceName" name="network[interface_name]" type="text" class="form-control">
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-3 control-label" for="network_description">Description</label>
      <div class="col-sm-9">
        <input id="network_description" v-model="description" name="network[description]" type="text" class="form-control">
      </div>
    </div>

    <div class="form-actions">
      <button type="submit" class="btn btn-primary">{{ submitLabel }}</button>
    </div>
  </form>
</template>

<script setup>
import { ref } from "vue"
import NetworkFormControls from "./NetworkFormControls.vue"

const props = defineProps({
  formAction: {
    type: String,
    required: true
  },
  formMethod: {
    type: String,
    default: "post"
  },
  submitLabel: {
    type: String,
    default: "Save"
  },
  initialName: {
    type: String,
    default: ""
  },
  initialIpv4: {
    type: String,
    default: ""
  },
  initialIpv6: {
    type: String,
    default: ""
  },
  initialVlan: {
    type: [String, Number],
    default: ""
  },
  initialSegmentTypeId: {
    type: [String, Number],
    default: ""
  },
  segmentTypeOptions: {
    type: Array,
    default: () => []
  },
  initialInterfaceName: {
    type: String,
    default: ""
  },
  initialDescription: {
    type: String,
    default: ""
  }
})

const csrfToken = document.querySelector("meta[name='csrf-token']")?.getAttribute("content") || ""
const effectiveMethod = props.formMethod.toLowerCase()
const name = ref(props.initialName)
const ipv4 = ref(props.initialIpv4)
const ipv6 = ref(props.initialIpv6)
const vlan = ref(String(props.initialVlan || ""))
const segmentTypeId = ref(String(props.initialSegmentTypeId || ""))
const interfaceName = ref(props.initialInterfaceName)
const description = ref(props.initialDescription)
</script>
